import React from "react"
import { Redirect } from "react-router-dom"

import Login from "../pages/Authentication/Login"
import Logout from "../pages/Authentication/Logout"
import ForgetPassword from '../pages/Authentication/ForgetPassword'
import Signup from "../pages/Authentication/Signup"
import Verify from "../pages/Authentication/Verify"
import Confirmed from "../pages/Authentication/Confirmed"
import ProductsView from '../pages/Products/View'
import Welcome from '../pages/Dashboard/Welcome'
import Home from '../pages/Home/Index'

import Catalogs from '../pages/Catalogs/Index'
import CatalogDetails from '../pages/Catalogs/View'
import CatalogPublic from '../pages/Catalogs/Public'
import CatalogProducts from '../pages/Catalogs/Products'
import CatalogProductDetail from '../pages/Catalogs/ProductDetail'

import Orders from '../pages/Orders/Index'
import OrdersDetail from '../pages/Orders/Detail'
import OrdersCreate from '../pages/Orders/Create'

import Devoluciones from '../pages/Devoluciones/Index'
import Profile from '../pages/Profile/Index'
import UserAddress from '../pages/UserAddress/Index'
import UserAddressCreate from '../pages/UserAddress/Create'
import MyAddress from '../pages/UserAddress/MyAddress'
import Cart from '../pages/Cart/Index'
import Checkout from '../pages/Cart/Checkout'
import OxxoReceipt from '../pages/Cart/OxxoReceipt'
import OrderConfirmed from '../pages/Cart/Confirmation'

import Store from '../pages/Store/Index'
import StoreCreate from '../pages/Store/Create'
import StoreProducts from '../pages/Store/Products'
import StoreShare from '../pages/Store/Share'
import ModifyProducts from '../pages/Store/ModifyProducts'

import Brands from '../pages/Brands/Index'
import ProductsByBrands from '../pages/Brands/Products'

import Academy from '../pages/Academy/Index'

import Discovery from '../pages/Discovery/Index'
import DiscoveryProduct from '../pages/Discovery/Product'

import WaitingList from '../pages/WaitingList/index'

const authProtectedRoutes = [
    { path: "/welcome", component: Welcome },
    { path: "/home", component: Home },
    { path: "/productos/ver/:id", component: ProductsView },
    { path: "/catalogos/detalles/:slug/productos/:productId", component: CatalogProductDetail },
    { path: "/catalogos/detalles/:slug/productos", component: CatalogProducts },
    { path: "/catalogos/detalles/:slug", component: CatalogDetails },
    { path: "/catalogos", component: Catalogs },
    { path: "/pedidos/agregar/:supplierId/:catalogId", component: OrdersCreate },
    { path: "/pedidos/agregar", component: OrdersCreate },
    { path: "/pedidos/editar/:id", component: OrdersCreate },
    { path: "/pedidos/detalle/:id", component: OrdersDetail },
    { path: "/pedidos", component: Orders },
    { path: "/devoluciones", component: Devoluciones },
    { path: "/perfil", component: Profile },
    { path: "/direcciones-envio/agregar", component: UserAddressCreate },
    { path: "/direcciones-envio/editar/:id", component: UserAddressCreate },
    { path: "/direcciones-envio", component: UserAddress },
    { path: "/carrito/:orderCreatedId/pagar", component: Checkout },
    { path: "/carrito/ficha-de-pago", component: OxxoReceipt },
    { path: "/carrito", component: Cart },
    { path: "/pedido-confirmado", component: OrderConfirmed },
    { path: "/mi-tienda/crear", component: StoreCreate },
    { path: "/mi-tienda/:storeId/productos/modificar", component: ModifyProducts },
    { path: "/mi-tienda/:storeId/productos", component: StoreProducts },
    { path: "/mi-tienda/:storeId/compartir", component: StoreShare },
    { path: "/mi-tienda", component: Store },
    { path: "/academia", component: Academy },
    { path: "/producto/:slug", component: DiscoveryProduct },
    { path: "/discovery", component: Discovery },
    { path: "/mis-direcciones", component: MyAddress },
    { path: "/marcas/:supplierCode", component: ProductsByBrands },
    { path: "/marcas", component: Brands },

    // this route should be at the end of all other routes
    { path: "/", exact: true, component: () => <Redirect to="/home" /> },
]

const publicRoutes = [
    { path: "/logout", component: Logout },
    { path: "/registrar", component: Signup },
    { path: "/verificar/:userId", component: Verify },
    { path: "/confirmacion", component: Confirmed },
    { path: "/login", component: Login },
    { path: "/forgot-password", component: ForgetPassword },
    { path: "/catalogo/:slug", component: CatalogPublic },
    { path: "/waiting-list", component: WaitingList }
]

export { authProtectedRoutes, publicRoutes }
